require('./cardChargeSuccessStep.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @commons
const { formatText, getLanguage, FormattedText } = require('core/i18n').i18n;
const { formatCurrency, formatAmount,formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LoadingDots } = require('commonsComponents/loadingDots');
const { toCamelCase, getLastNChars } = require('utilities/stringHelper');

//@ Helpers
const dateHelper = require('utilities/dateHelper');
const { getCardAvailableBalance } = require('utilities/cardsHelper');

// @constants
const {
    CARD_CHARGE_OPERATION_CHARGE,
    CARD_CHARGE_SAVINGS_OPERATION_REJECT,
    DATE_FORMAT_ES,
    DATE_FORMAT_EN,
    PERIODICITY_CONSTANTLY,
    PERIODICITY_DATE,
    PERIODICITY_COUNT,
    CARD_CHARGE_OPERATION_REJECT,
    MONEY_REQUEST_VIEW,
    SAVINGS_REQUEST_VIEW
} = require('constants/index');

class CardChargeSuccessStep extends React.Component {
    constructor(props) {
        super(props);
        this.buildListItems = this.buildListItems.bind(this);
    }

    componentWillMount() {
        const { immCard, requestEcardInfo } = this.props;
        requestEcardInfo(immCard.get('cardId'));
    }

    getAvailableBalance() {
        const {
            immCard
        } = this.props;
        return {
            amount: immCard.getIn(['extra', 'eCardInfo', 'saldoActualPrepago', 'importe']),
            currency: immCard.getIn(['extra', 'eCardInfo', 'saldoActualPrepago', 'divisa'])
        };
    }

    getPrepaidBalance(availableBalance) {
        const { loading } = this.props;
        const plainAmountObject = getPlainAmountObject(availableBalance);

        if (loading) {
            return <LoadingDots inline color="dark" size="small" />;
        }

        return (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={getLanguage()}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
        );
    }

    buildListItems(list){
        const modifiedList = list.map((data, index) => {
            const extraClassName = (data.title.replace(/\s/g, '-')).toLowerCase();
            if(data.key){
                return(
                    <OKInformativeListItem
                        bodyText={data.key}
                        bodyWordBreak={false}
                        key={index}
                        title={data.title}
                        className={`list-item-${extraClassName}`}
                    />
                );
            }
        });
        return modifiedList;
    }

    buildPeriodicityText() {
        const firstStep = this.props.immCardCharge.getIn(['steps', 0]);
        const rangeType = firstStep.get('periodicityRange').toLowerCase();
        const rangeTypeHumanReadable = formatText(`periodicity-${rangeType}`);

        return rangeTypeHumanReadable;
    }

    render() {
        const { immCard, immCardCharge, immAccounts, view } = this.props;
        const amount = parseFloat(immCardCharge.getIn(['steps', 0, 'amount']));
        const availableBalance = (view === MONEY_REQUEST_VIEW) ? getCardAvailableBalance(immCard) : this.getAvailableBalance();
        const availableBalanceMessage = this.getPrepaidBalance(availableBalance);
        const currency = formatCurrency(availableBalance.currency);
        const operationAmount = `${formatAmount(amount)} ${currency}`;
        const operationType = immCardCharge.getIn(['steps', 0, 'operationType']);
        let operationMesssage, title, balanceMessage, moneyRequestDetails, linkToMovements, goBackButtonLabel;
        const immCardChargeStep1 = immCardCharge.getIn(['steps', 0]);
        const periodicityEnabled = immCardChargeStep1.get('periodicityEnabled');
        const periodicityConcept = immCardChargeStep1.get('periodicityConcept');
        const cardAlias = immCard.getIn(['alias', 'current']);
        const isEditFlow = immCardChargeStep1.get('isEdit');
        goBackButtonLabel = formatText('cardChargeSuccess-backToCard', [
            cardAlias
        ]).toUpperCase();
        linkToMovements = `/myprofile/cards/${immCard.get('cardId')}/movements`;

        if(operationType === CARD_CHARGE_OPERATION_REJECT) {
            title = formatText('moneyRequestView-rejectRequestSuccessTitle');
            balanceMessage = <FormattedText value="moneyRequestView-rejectRequestSuccessMessage" injectedStrings={[operationAmount]} />;
        } else if (operationType === CARD_CHARGE_SAVINGS_OPERATION_REJECT) {
            title = formatText('moneySavingsRequest-cancelSuccessTitle');
            balanceMessage = <FormattedText value="moneySavingsRequest-cancelSuccessMessage" injectedStrings={[operationAmount]} />;
            linkToMovements = `/myprofile/global`;
            goBackButtonLabel = formatText('moneySavingsRequest-backLink', [
                cardAlias
           ]).toUpperCase();
        } else {
            if (operationType === CARD_CHARGE_OPERATION_CHARGE) {
                operationMesssage = formatText('cardChargeSuccess-charge');
                title = formatText('cardChargeSuccess-successfullyCharged', [
                    operationMesssage,
                    operationAmount
                ]);
                if(periodicityEnabled) {
                    if(isEditFlow) {
                        if(immCard.get('isOpenYoung')) {
                            title = formatText('editCardCharge-successfullyOpenYoungPeriodicCharged');
                        } else {
                            title = formatText('editCardCharge-successfullyEcardPeriodicCharged');
                        }
                    } else {
                        if(immCard.get('isOpenYoung')) {
                            title = formatText('cardChargeSuccess-successfullyOpenYoungPeriodicCharged', [
                                operationAmount
                            ]);
                        } else {
                            title = formatText('cardChargeSuccess-successfullyEcardPeriodicCharged', [
                                operationAmount
                            ]);
                        }
                    }
                }
			} else {
                operationMesssage = formatText('cardChargeSuccess-discharge');
                title = formatText('cardChargeSuccess-successfullyCharged', [
                    operationMesssage,
                    operationAmount
                ]);
            }
		}
		if(view === MONEY_REQUEST_VIEW || view === SAVINGS_REQUEST_VIEW) {
            const titleContent = (view === SAVINGS_REQUEST_VIEW) ? 'moneySavingsRequest-successTitle' : 'moneyRequestView-acceptSuccessMessage';
            title = formatText(titleContent, [
                operationAmount
            ]);
            const accountId = immCardCharge.getIn(['steps', '0', 'accountId']);
            const immAccount = immAccounts.getIn(['byId', accountId]);
            const accountAlias = immAccount.get('alias');
            const iban = immAccount.get('iban');
            const formattedIBAN = getLastNChars(iban);
            const accountAliasIban = `${accountAlias} ${formattedIBAN}`;
            moneyRequestDetails = (
                <OKInformativeList columns={1}>
                    <OKInformativeListItem
                        title="cardCharge-accounts"
                        bodyText={accountAliasIban}
                    />
                    <OKInformativeListItem
                        title="cardCharge-amount"
                        bodyText={operationAmount}
                    />
                </OKInformativeList>
            );
            if(view === SAVINGS_REQUEST_VIEW) {
                goBackButtonLabel = formatText('moneySavingsRequest-backLink', [
                    cardAlias
                ]).toUpperCase();
                linkToMovements = `/myprofile/global`;
            }
        }
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToMovements
        };

        let fromAccount;
        let endDateValue;
        let startDateValue;
        let list;

        if(operationType !== CARD_CHARGE_OPERATION_REJECT && operationType !== CARD_CHARGE_SAVINGS_OPERATION_REJECT) {
            const accountId = immCardChargeStep1.get('accountId');
            const immAccount = immAccounts.getIn(['byId', accountId]);
            const alias = immAccount.get('alias') || toCamelCase(immAccount.get('accountType'));
            const fromIBAN = getLastNChars(immAccount.get('iban'));
            const dateFormat = getLanguage() === 'es' ? DATE_FORMAT_ES : DATE_FORMAT_EN;

            if(operationType === CARD_CHARGE_OPERATION_CHARGE && periodicityEnabled) {
                fromAccount = `${alias} ${fromIBAN}`;
                startDateValue = dateHelper.buildFormattedDate(
                    immCardChargeStep1.get('date'),
                    dateFormat
                );

                switch (immCardChargeStep1.get('periodicityType')) {
                    case PERIODICITY_CONSTANTLY:
                        endDateValue = formatText('periodicity-constantly');
                    break;
                    case PERIODICITY_DATE:
                        endDateValue = dateHelper.buildFormattedDate(
                                immCardChargeStep1.get('periodicityDate'),
                                dateFormat
                            );
                    break;
                    case PERIODICITY_COUNT:
                        endDateValue = dateHelper.buildFormattedDate(
                            immCardChargeStep1.get('periodicityEstimatedEndDate'),
                            dateFormat
                        );
                    break;
                }
            }
        }

        if(operationType === CARD_CHARGE_OPERATION_CHARGE && periodicityEnabled) {
            list = [
                {
                    key: fromAccount,
                    title: formatText('cardCharge-accounts')
                },
                {
                    key: operationAmount,
                    title: formatText('transferSuccessful-import')
                },
                {
                    key: startDateValue,
                    title: formatText('cardCharge-startDate')
                },
                {
                    key: endDateValue,
                    title: formatText('cardCharge-endDate')
                },
                {
                    key: periodicityEnabled
                    ? this.buildPeriodicityText()
                    : formatText('transferSummary-step2NoRepetitions'),
                    title: formatText('transferSummary-step2Periodicity')
                },
                {
                  key: periodicityConcept,
                  title: formatText('cardCharge-concept')
                }
            ];
        } else if(operationType !== CARD_CHARGE_OPERATION_REJECT && operationType !== CARD_CHARGE_SAVINGS_OPERATION_REJECT) {
            list = [
                {
                    key: availableBalanceMessage,
                    title: formatText('cardChargeSuccess-newBalance')
                }
            ];
        }

        const listData = list ? this.buildListItems(list) : '';
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 card-charge-success">
                <WizardSuccess
                    successMessage={title}
                    mainButton={goBackButton}>
                    <section className="row">
                        <div className="col-xs-5">
                            <CommercialAds
                                path="cards"
                                type="cards"
                                immCard={immCard}
                            />
                        </div>
                        <div className="col-xs-7">
                            <OKInformativeList columns={2}>
                                {listData}
                            </OKInformativeList>
                            {balanceMessage}
                            {moneyRequestDetails}
                        </div>
                    </section>
                </WizardSuccess>
            </div>
        );
    }
}

CardChargeSuccessStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    immCardCharge: PropTypes.object.isRequired,
    requestEcardInfo: PropTypes.func,
    loading: PropTypes.bool,
    view: PropTypes.string
};

CardChargeSuccessStep.defaultProps = {
    requestEcardInfo: () => {},
    loading: false
}

module.exports = CardChargeSuccessStep;
